import React from "react";
import { CalendarCheck, Camera, Sprout, AlertTriangle, Droplets, ClipboardList, Star, Tag, ArrowRight } from "lucide-react";
import { Button } from "./ui/button";

const items = [
  { icon: CalendarCheck, t: "Årlig visuell takkontroll" },
  { icon: Camera, t: "Fotodokumentation" },
  { icon: Sprout, t: "Kontroll av mossa & alger" },
  { icon: AlertTriangle, t: "Kontroll av synliga skador" },
  { icon: Droplets, t: "Kontroll av hängrännor" },
  { icon: ClipboardList, t: "Underhållsrekommendation" },
  { icon: Star, t: "Prioriterad service" },
  { icon: Tag, t: "Förmånliga priser på framtida behandlingar" },
];

export default function HprCare() {
  return (
    <section id="hprcare" className="relative overflow-hidden hpr-gradient text-white py-16 lg:py-24 scroll-mt-20">
      <div className="pointer-events-none absolute -top-16 -right-16 w-[420px] h-[420px] rounded-full bg-white/5 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-6">
        <div className="reveal max-w-3xl">
          <p className="text-sm font-bold uppercase tracking-[0.15em] text-[#8fb4ff]">Återkommande skötsel</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold leading-tight">
            HPR Care – vi tar hand om ditt tak <span className="text-[#38BDF8]">även efter jobbet</span>
          </h2>
          <p className="mt-4 text-lg text-white/80">
            Ett rent tak håller sig inte rent av sig självt. Med HPR Care får du regelbunden koll,
            dokumentation och prioriterad service – så att små saker aldrig hinner bli dyra problem.
          </p>
        </div>

        <div className="reveal mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((it) => (
            <div key={it.t} className="rounded-2xl bg-white/10 p-5 ring-1 ring-white/15 backdrop-blur-sm">
              <it.icon className="w-6 h-6 text-[#38BDF8]" />
              <p className="mt-3 text-sm font-semibold text-white">{it.t}</p>
            </div>
          ))}
        </div>

        <div className="reveal mt-8">
          <Button asChild className="rounded-full h-13 px-8 py-3 bg-[#ffffff] text-[#1B45C4] hover:bg-[#e6edff] font-semibold">
            <a href="#kontakt" data-testid="hprcare-cta">Upptäck HPR Care <ArrowRight className="ml-2 w-5 h-5" /></a>
          </Button>
        </div>
      </div>
    </section>
  );
}
